<template>
  <div>
    <div v-if="!isLoggedIn">
      <h1 class="mb-6">Passwort zurücksetzen</h1>

        <form v-if="!codeSent" v-on:submit.prevent="userForgotPasswdAction()" class="max-w-md">
          <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-mail">
            Deine E-Mail Adresse
            <input v-model="loginData.email" required class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-mail" type="text" autocomplete="email" placeholder="Deine E-Mail Adresse" />
          </label>
          <input type="submit" class="block w-full mt-4 shadow bg-green-heinz text-white font-bold mt-2 py-2 px-4 rounded" value="Passwort zurücksetzen" />
        </form>

        <div v-if="codeSent" class="bg-orange-lightest border-l-4 border-orange text-orange-dark p-4 mb-4" role="alert">
          <p class="font-bold">Rettungs-Code versendet</p>
          <p>Wenn du deine E-Mail Adresse ({{ loginData.email }}) korrekt eingegeben hast und es einen Account mit dieser Adresse gibt, haben wir dir einen Code zum Zurücksetzen deines Passworts per Mail gesendet. Bitte gib diesen Code hier anschließend ein um dein Passwort zu ändern.</p>
        </div>

        <form v-if="codeSent" v-on:submit.prevent="userUpdatePasswordByCodeAction()" class="max-w-md">
          <label class="block uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-code">
            Dein Rettungs-Code (kommt per Mail)
            <input v-model="loginData.code" required class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-code" type="text" autocomplete="off" placeholder="" />
          </label>
          <label class="block mt-4 uppercase tracking-wide text-grey-darker text-sm font-bold" for="grid-passwd">
            Dein neues Passwort
            <input v-model="loginData.passwd" required minlength="8" class="appearance-none block w-full text-grey-darker border border-green-heinz rounded py-3 px-4" id="grid-passwd" type="password" autocomplete="off" placeholder="" />
          </label>
          <input type="submit" class="block w-full mt-4 shadow bg-green-heinz text-white font-bold mt-2 py-2 px-4 rounded" value="Passwort zurücksetzen" />
          <a href="javascript:void(0)" v-on:click="codeSent=false" class="block mt-4 text-sm text-grey-dark">abbrechen</a>
        </form>
    </div>
    <div v-else>
      <div class="mt-4 bg-orange-lightest border-l-4 border-orange text-orange-dark p-4 mb-4" role="alert">
        <p class="font-bold">Du bist bereits eingeloggt</p>
        <p>Da du bereits eingeloggt bist, hast du dein Passwort wohl nicht vergessen 🧐</p>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'userForgotPasswd',

  data () {
    return {
      loginData: {
        email: '',
        passwd: '',
        code: ''
      },
      codeSent: false
    }
  },

  computed: {
    ...mapGetters([
      'isLoggedIn'
    ])
  },

  methods: {
    ...mapActions([
      'userForgotPasswd',
      'userResetPasswd'
    ]),

    userForgotPasswdAction () {
      this.codeSent = true
      this.userForgotPasswd(this.loginData)
    },

    userUpdatePasswordByCodeAction () {
      this.userResetPasswd(this.loginData)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/forgotpasswd.vue